import { render } from "./CXSettings.vue?vue&type=template&id=35ddee38&scoped=true"
import script from "./CXSettings.vue?vue&type=script&lang=js"
export * from "./CXSettings.vue?vue&type=script&lang=js"

import "./CXSettings.vue?vue&type=style&index=0&id=35ddee38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ddee38"]])

export default __exports__